// Application
export const APP_VERSION = "V.32.0.29";
export const APP_VERSION_DATE = "de 22/10/2026";

// Date
export const MASK_TIMESTAMPSEC = "yyyy-MM-dd'T'HH:mm:ss";
export const MASK_TIMESTAMP = "yyyy-MM-dd'T'HH:mm";
export const MASK_DATETIMESEC_BR = "dd/MM/yyyy HH:mm:ss";
export const MASK_DATETIME_BR = "dd/MM/yyyy HH:mm";
export const MASK_DATE_BR = "dd/MM/yyyy";
export const MASK_DATE = "yyyy-MM-dd";
export const MASK_TIME = "HH:mm";

// Record
export const NO_RECORD_FOUND = "Nenhum registro encontrado";

export const promptMessage =
    "É possível que as alterações feitas não sejam salvas.";

// Schedule
const titleRecreation = "Recreio - Estudantes";
export const RECREATION = [
    {
        title: titleRecreation,
        daysOfWeek: ["1", "2", "3", "4", "5"],
        startTime: "09:20:00",
        endTime: "09:40:00",
        color: "#D5FFB1",
        textColor: "#404040",
        editable: false,
    },
    {
        title: titleRecreation,
        daysOfWeek: ["1", "2", "3", "4", "5"],
        startTime: "14:55:00",
        endTime: "15:15:00",
        color: "#D5FFB1",
        textColor: "#404040",
        editable: false,
    },
    {
        title: titleRecreation,
        daysOfWeek: ["1", "2", "3", "4", "5"],
        startTime: "20:30:00",
        endTime: "20:45:00",
        color: "#D5FFB1",
        textColor: "#404040",
        editable: false,
    },
    {
        title: titleRecreation,
        daysOfWeek: ["6"],
        startTime: "09:20:00",
        endTime: "09:40:00",
        color: "#D5FFB1",
        textColor: "#404040",
        editable: false,
    },
    {
        title: titleRecreation,
        daysOfWeek: ["6"],
        startTime: "14:55:00",
        endTime: "15:15:00",
        color: "#D5FFB1",
        textColor: "#404040",
        editable: false,
    },
    {
        title: titleRecreation,
        daysOfWeek: ["6"],
        startTime: "20:30:00",
        endTime: "20:45:00",
        color: "#D5FFB1",
        textColor: "#404040",
        editable: false,
    },
] as any[];
